/// <reference path="../../polaris-web-components.d.ts" />
import React from 'react';
import { FormatTimeDuration } from '../common/FormatTimeDuration';

export default function ImportNotification({ item, bulkCancelStatus, cancelBulk, generateProductErrorModal, generateMetafieldErrorModal, generateUploadWarningsModal,generateCombinedErrorModal, emailMarketingUpdate,isCustomerImport }) {
    const resourceName = {
        singular: 'notification',
        plural: 'notifications'
    };
    
    // Map translation register/remove to update/create structure for compatibility
    const normalizedItem = { ...item };
    if (item?.type === "translationuploadbulk") {
        if (item?.register) {
            normalizedItem.update = item.register;
        }
        if (item?.remove) {
            normalizedItem.create = item.remove;
        }
    }
    
    return (
        <s-box paddingBlockStart="base">
        <s-section padding="none">
            <s-box padding="base">
                <s-grid gridTemplateColumns="1fr auto" gap="none">
                    <s-grid-item>
                        <s-heading>
                            {normalizedItem?.type === "customeruploadbulk" ? "Current bulk operation: Customers" :
                                normalizedItem?.type === "collectionuploadbulk" ? "Current bulk operation: Collections" : 
                                normalizedItem?.type === "metafielduploadbulk" ? "Current bulk operation: Metafields" : 
                                normalizedItem?.type === "metaobjectuploadbulk" ? "Current bulk operation: Metaobjects" : 
                                normalizedItem?.type === "translationuploadbulk" ? "Current bulk operation: Translations" : 
                                "Current bulk operation: Products"}
                        </s-heading>
                    </s-grid-item>
                    <s-grid-item>
                        <s-button
                            variant='tertiary'
                            onClick={() => { cancelBulk(normalizedItem?.bulkId) }}
                            icon="x"
                        >
                            {bulkCancelStatus === "" ? "Cancel" : <s-text tone='warning'>{bulkCancelStatus}</s-text>}
                        </s-button>
                    </s-grid-item>
                </s-grid>
            </s-box>
            <s-stack gap="small">
                <s-table
                    itemCount={3}
                    selectable={false}
                >
                    <s-table-header-row>
                        <s-table-header>Id</s-table-header>
                        <s-table-header>Type</s-table-header>
                        <s-table-header>Created at</s-table-header>
                        <s-table-header>Items</s-table-header>
                        <s-table-header>Duration</s-table-header>
                        <s-table-header>Errors</s-table-header>
                        <s-table-header>Warnings</s-table-header>
                        <s-table-header>Status</s-table-header>
                        <s-table-header></s-table-header>
                    </s-table-header-row>
                    <s-table-body>
                    {normalizedItem?.update ?
                        <s-table-row
                            id={1}
                            key={1}
                        >
                            <s-table-cell>
                                <s-stack direction="inline" gap="small">
                                    <s-text type="strong">{'#' + normalizedItem?.id}</s-text>
                                    {normalizedItem?.catalogUrl ? (
                                        <s-link url={normalizedItem?.catalogUrl} download={normalizedItem?.catalogUrl.split('/').pop()}>
                                            <s-icon type="upload" tone='base' />
                                        </s-link>
                                    ) : null}
                                </s-stack>
                            </s-table-cell>
                            <s-table-cell><s-text type="strong">{normalizedItem?.type === "translationuploadbulk" ? "Register" : "Update"}</s-text></s-table-cell>
                            <s-table-cell>{normalizedItem?.update.startTime ? normalizedItem?.update.timeAgo : "_"}</s-table-cell>
                            <s-table-cell>{normalizedItem?.update.completed + "/" + normalizedItem?.update.total}</s-table-cell>
                            {/* <IndexTable.Cell><div style={{ width: '125px' }}>
                                <ProgressBar progress={normalizedItem?.update.completed != 0 ? (normalizedItem?.update.completed / normalizedItem?.update.total) * 100 : 0} size="medium" />
                            </div></IndexTable.Cell> */}
                            <s-table-cell>{normalizedItem?.update.endTime ? FormatTimeDuration(normalizedItem?.update.startTime, normalizedItem?.update.endTime) : "_"}</s-table-cell>
                            <s-table-cell>{((normalizedItem?.update.errors && normalizedItem?.update.errors.length > 0) || (isCustomerImport && normalizedItem?.update.metaErrors && normalizedItem?.update.metaErrors.length > 0)) ?
                                <s-link tone="critical" onClick={() => {
                                    if (isCustomerImport && normalizedItem?.update.metaErrors && normalizedItem?.update.metaErrors.length > 0) {
                                        generateCombinedErrorModal(normalizedItem?.update.errors || [], normalizedItem?.update.metaErrors || []);
                                    } else {
                                        generateProductErrorModal(normalizedItem?.update.errors);
                                    }
                                }}>
                                    <s-text tone="critical">
                                        {isCustomerImport ? (normalizedItem?.update.errors?.length || 0) + (normalizedItem?.update.metaErrors?.length || 0) : normalizedItem?.update.errors?.length} errors
                                    </s-text>
                                </s-link>
                                : <s-text tone="success">_</s-text>}
                            </s-table-cell>
                            <s-table-cell>
                                {(normalizedItem?.uploadErrors?.length > 0) ?
                                    <s-stack direction="inline" gap="small">
                                        <s-link tone="warning" onClick={() => generateUploadWarningsModal(normalizedItem?.uploadErrors)}>
                                            <s-text tone="warning">{normalizedItem?.uploadErrors?.length} warnings</s-text></s-link>
                                    </s-stack>

                                    : <s-text tone="success">{normalizedItem?.update?.status  !== "canceled" ? "_" : "_"}</s-text>}
                            </s-table-cell>
                            <s-table-cell><s-badge tone={normalizedItem?.update.status === "completed" ? "success" : "info"}>{normalizedItem?.update.status}</s-badge></s-table-cell>
                            <s-table-cell>
                                {normalizedItem?.update?.status !== "completed" && bulkCancelStatus === "" ?
                                    <s-spinner size='small' />
                                    : null}
                                {/* {bulkCancelStatus === "" ? <Button plain onClick={() => { cancelBulk(normalizedItem?.bulkId) }}>&nbsp;Cancel</Button> :
                                    <Text tone='warning'>&nbsp;{bulkCancelStatus}</Text>} */}
                            </s-table-cell>

                        </s-table-row> : null}
                    {normalizedItem?.create ?
                        <s-table-row>
                            <s-table-cell>
                                {/* <s-text type="strong"></s-text> */}
                                <s-stack direction="inline" gap="small">
                                    <s-text type="strong">{item?.update ? "" : '#' + item?.id}</s-text>
                                    {item?.catalogUrl && item?.update === null ? (
                                        <s-link url={item?.catalogUrl} download={item?.catalogUrl.split('/').pop()}>
                                            <s-icon type="upload" tone='base' />
                                        </s-link>
                                    ) : null}
                                </s-stack>
                            </s-table-cell>
                            <s-table-cell><s-text type="strong">Create</s-text></s-table-cell>
                            <s-table-cell>{item?.create.startTime ? item?.create.timeAgo : "_"}</s-table-cell>
                            <s-table-cell>{item?.create.completed + "/" + item?.create.total}</s-table-cell>
                            {/* <s-table-cell><div style={{ width: '125px' }}>
                                <ProgressBar progress={item?.create.completed != 0 ? (item?.create.completed / item?.create.total) * 100 : 0} size="medium" />
                            </div></s-table-cell> */}
                            <s-table-cell>{item?.create.endTime ? FormatTimeDuration(item?.create.startTime, item?.create.endTime) : "_"}</s-table-cell>
                            <s-table-cell>{((item?.create.errors && item?.create.errors.length > 0) || (isCustomerImport && item?.create.metaErrors && item?.create.metaErrors.length > 0)) ?
                                <s-link tone="critical" onClick={() => {
                                    if (isCustomerImport && item?.create.metaErrors && item?.create.metaErrors.length > 0) {
                                        generateCombinedErrorModal(item?.create.errors || [], item?.create.metaErrors || []);
                                    } else {
                                        generateProductErrorModal(item?.create.errors);
                                    }
                                }}>
                                    <s-text tone="critical">
                                        {isCustomerImport ? (item?.create.errors?.length || 0) + (item?.create.metaErrors?.length || 0) : item?.create.errors?.length} errors
                                    </s-text>
                                </s-link>
                                : <s-text tone="success">-</s-text>}
                            </s-table-cell>
                            <s-table-cell>
                                {(item?.uploadErrors?.length > 0) ?
                                    <s-stack direction="inline" gap="small">
                                        <s-link tone="warning" onClick={() => generateUploadWarningsModal(item?.uploadErrors)}>
                                            <s-text tone="warning">{item?.uploadErrors?.length} warnings</s-text></s-link>
                                    </s-stack>

                                    : <s-text tone="success">{item?.create?.status  !== "canceled" ? "_" : "_"}</s-text>}
                            </s-table-cell>
                            <s-table-cell><s-badge tone={item?.create.status === "completed" ? "success" : "info"}>{item?.create.status}</s-badge></s-table-cell>
                            <s-table-cell>
                                {item?.create?.status !== "completed" && (item?.update !== null ? item?.update?.status === "completed" : true) && bulkCancelStatus === "" ?
                                    <s-spinner size='small' />
                                    : null}
                            </s-table-cell>
                        </s-table-row> : null}

                    {item?.variantUpdate ?
                        <s-table-row>
                            <s-table-cell>
                                {/* <s-text type="strong"></s-text> */}
                                <s-stack direction="inline" gap="small">
                                    <s-text type="strong">{item?.update ? "" : '#' + item?.id}</s-text>
                                    {item?.catalogUrl && item?.update === null ? (
                                        <s-link url={item?.catalogUrl} download={item?.catalogUrl.split('/').pop()}>
                                            <s-icon type="upload" tone='base' />
                                        </s-link>
                                    ) : null}
                                </s-stack>
                            </s-table-cell>
                            <s-table-cell><s-text type="strong">Inventory update</s-text></s-table-cell>
                            <s-table-cell>{item?.variantUpdate.startTime ? item?.variantUpdate.timeAgo : "_"}</s-table-cell>
                            <s-table-cell>{item?.variantUpdate.completed + "/" + item?.variantUpdate.total}</s-table-cell>
                            {/* <s-table-cell><div style={{ width: '125px' }}>
                                <ProgressBar progress={item?.create.completed != 0 ? (item?.create.completed / item?.create.total) * 100 : 0} size="medium" />
                            </div></s-table-cell> */}
                            <s-table-cell>{item?.variantUpdate.endTime ? FormatTimeDuration(item?.variantUpdate.startTime, item?.variantUpdate.endTime) : "_"}</s-table-cell>
                            <s-table-cell>{(item?.variantUpdate.errors && item?.variantUpdate.errors.length > 0) ?
                                <s-link tone="critical" onClick={() => generateProductErrorModal(item?.variantUpdate.errors)}>
                                    <s-text tone="critical">{item?.variantUpdate.errors.length} errors</s-text></s-link>
                                : <s-text tone="success">-</s-text>}
                            </s-table-cell>
                            <s-table-cell>{"_"}</s-table-cell>
                            <s-table-cell><s-badge tone={item?.variantUpdate.status === "completed" ? "success" : "info"}>{item?.variantUpdate.status}</s-badge></s-table-cell>
                            <s-table-cell>
                                {item?.variantUpdate?.status !== "completed" && (item?.update !== null ? item?.update?.status === "completed" : true) && bulkCancelStatus === "" ?
                                    <s-spinner size='small' />
                                    : null}
                            </s-table-cell>
                        </s-table-row> : null}



                    {item?.variantCreate ?
                        <s-table-row>
                            <s-table-cell>
                                {/* <s-text type="strong"></s-text> */}
                                <s-stack direction="inline" gap="small">
                                    <s-text type="strong">{item?.update ? "" : '#' + item?.id}</s-text>
                                    {item?.catalogUrl && item?.update === null ? (
                                        <s-link url={item?.catalogUrl} download={item?.catalogUrl.split('/').pop()}>
                                            <s-icon type="upload" tone='base' />
                                        </s-link>
                                    ) : null}
                                </s-stack>
                            </s-table-cell>
                            <s-table-cell><s-text type="strong">Variant create</s-text></s-table-cell>
                            <s-table-cell>{item?.variantCreate.startTime ? item?.variantCreate.timeAgo : "_"}</s-table-cell>
                            <s-table-cell>{item?.variantCreate.completed + "/" + item?.variantCreate.total}</s-table-cell>
                            {/* <s-table-cell><div style={{ width: '125px' }}>
                                <ProgressBar progress={item?.create.completed != 0 ? (item?.create.completed / item?.create.total) * 100 : 0} size="medium" />
                            </div></s-table-cell> */}
                            <s-table-cell>{item?.variantCreate.endTime ? FormatTimeDuration(item?.variantCreate.startTime, item?.variantCreate.endTime) : "_"}</s-table-cell>
                            <s-table-cell>{(item?.variantCreate.errors && item?.variantCreate.errors.length > 0) ?
                                <s-link tone="critical" onClick={() => generateProductErrorModal(item?.variantCreate.errors)}>
                                    <s-text tone="critical">{item?.variantCreate.errors.length} errors</s-text></s-link>
                                : <s-text tone="success">-</s-text>}
                            </s-table-cell>
                            <s-table-cell>{"_"}</s-table-cell>
                            <s-table-cell><s-badge tone={item?.variantCreate.status === "completed" ? "success" : "info"}>{item?.variantCreate.status}</s-badge></s-table-cell>
                            <s-table-cell>
                                {item?.variantCreate?.status !== "completed" && (item?.update !== null ? item?.update?.status === "completed" : true) && bulkCancelStatus === "" ?
                                    <s-spinner size='small' />
                                    : null}
                            </s-table-cell>
                        </s-table-row> : null}


                    {item?.mediaCreate ?
                        <s-table-row>
                            <s-table-cell>
                                {/* <s-text type="strong"></s-text> */}
                                <s-stack direction="inline" gap="small">
                                    <s-text type="strong">{item?.update ? "" : '#' + item?.id}</s-text>
                                    {item?.catalogUrl && item?.update === null ? (
                                        <s-link url={item?.catalogUrl} download={item?.catalogUrl.split('/').pop()}>
                                            <s-icon type="upload" tone='base' />
                                        </s-link>
                                    ) : null}
                                </s-stack>
                            </s-table-cell>
                            <s-table-cell><s-text type="strong">Media create</s-text></s-table-cell>
                            <s-table-cell>{item?.mediaCreate.startTime ? item?.mediaCreate.timeAgo : "_"}</s-table-cell>
                            <s-table-cell>{item?.mediaCreate.completed + "/" + item?.mediaCreate.total}</s-table-cell>
                            {/* <s-table-cell><div style={{ width: '125px' }}>
                                <ProgressBar progress={item?.create.completed != 0 ? (item?.create.completed / item?.create.total) * 100 : 0} size="medium" />
                            </div></s-table-cell> */}
                            <s-table-cell>{item?.mediaCreate.endTime ? FormatTimeDuration(item?.mediaCreate.startTime, item?.mediaCreate.endTime) : "_"}</s-table-cell>
                            <s-table-cell>{(item?.mediaCreate.errors && item?.mediaCreate.errors.length > 0) ?
                                <s-link tone="critical" onClick={() => generateProductErrorModal(item?.mediaCreate.errors)}>
                                    <s-text tone="critical">{item?.mediaCreate.errors.length} errors</s-text></s-link>
                                : <s-text tone="success">-</s-text>}
                            </s-table-cell>
                            <s-table-cell>{"_"}</s-table-cell>
                            <s-table-cell><s-badge tone={item?.mediaCreate.status === "completed" ? "success" : "info"}>{item?.mediaCreate.status}</s-badge></s-table-cell>
                            <s-table-cell>
                                {item?.mediaCreate?.status !== "completed" && (item?.update !== null ? item?.update?.status === "completed" : true) && bulkCancelStatus === "" ?
                                    <s-spinner size='small' />
                                    : null}
                            </s-table-cell>
                        </s-table-row> : null}


                    {item?.mediaUpdate ?
                        <s-table-row>
                            <s-table-cell>
                                {/* <s-text type="strong"></s-text> */}
                                <s-stack direction="inline" gap="small">
                                    <s-text type="strong">{item?.update ? "" : '#' + item?.id}</s-text>
                                    {item?.catalogUrl && item?.update === null ? (
                                        <s-link url={item?.catalogUrl} download={item?.catalogUrl.split('/').pop()}>
                                            <s-icon type="upload" tone='base' />
                                        </s-link>
                                    ) : null}
                                </s-stack>
                            </s-table-cell>
                            <s-table-cell><s-text type="strong">Media update</s-text></s-table-cell>
                            <s-table-cell>{item?.mediaUpdate.startTime ? item?.mediaUpdate.timeAgo : "_"}</s-table-cell>
                            <s-table-cell>{item?.mediaUpdate.completed + "/" + item?.mediaUpdate.total}</s-table-cell>
                            {/* <s-table-cell><div style={{ width: '125px' }}>
                                <ProgressBar progress={item?.create.completed != 0 ? (item?.create.completed / item?.create.total) * 100 : 0} size="medium" />
                            </div></s-table-cell> */}
                            <s-table-cell>{item?.mediaUpdate.endTime ? FormatTimeDuration(item?.mediaUpdate.startTime, item?.mediaUpdate.endTime) : "_"}</s-table-cell>
                            <s-table-cell>{(item?.mediaUpdate.errors && item?.mediaUpdate.errors.length > 0) ?
                                <s-link tone="critical" onClick={() => generateProductErrorModal(item?.mediaUpdate.errors)}>
                                    <s-text tone="critical">{item?.mediaUpdate.errors.length} errors</s-text></s-link>
                                : <s-text tone="success">-</s-text>}
                            </s-table-cell>
                            <s-table-cell>{"_"}</s-table-cell>
                            <s-table-cell><s-badge tone={item?.mediaUpdate.status === "completed" ? "success" : "info"}>{item?.mediaUpdate.status}</s-badge></s-table-cell>
                            <s-table-cell>
                                {item?.mediaUpdate?.status !== "completed" && (item?.update !== null ? item?.update?.status === "completed" : true) && bulkCancelStatus === "" ?
                                    <s-spinner size='small' />
                                    : null}
                            </s-table-cell>
                        </s-table-row> : null}


                    {item?.metaUpdate ?
                        <s-table-row>
                            <s-table-cell>
                                {/* <s-text type="strong"></s-text> */}
                                <s-stack direction="inline" gap="small">
                                    <s-text type="strong">{item?.update ? "" : '#' + item?.id}</s-text>
                                    {item?.catalogUrl && item?.update === null ? (
                                        <s-link url={item?.catalogUrl} download={item?.catalogUrl.split('/').pop()}>
                                            <s-icon type="upload" tone='base' />
                                        </s-link>
                                    ) : null}
                                </s-stack>
                            </s-table-cell>
                            <s-table-cell><s-text type="strong">Metafields</s-text></s-table-cell>
                            <s-table-cell>{item?.metaUpdate.startTime ? item?.metaUpdate.timeAgo : "_"}</s-table-cell>
                            <s-table-cell>{item?.metaUpdate.completed + "/" + item?.metaUpdate.total}</s-table-cell>
                            {/* <s-table-cell><div style={{ width: '125px' }}>
                                <ProgressBar progress={item?.metaUpdate.completed != 0 ? (item?.metaUpdate.completed / item?.metaUpdate.total) * 100 : 0} size="medium" />
                            </div></s-table-cell> */}
                            <s-table-cell>{item?.metaUpdate.endTime ? FormatTimeDuration(item?.metaUpdate.startTime, item?.metaUpdate.endTime) : "_"}</s-table-cell>
                            <s-table-cell>{(item?.metaUpdate.metaErrors && item?.metaUpdate.metaErrors.length > 0) ?
                                <s-link tone="critical" onClick={() => generateMetafieldErrorModal(item?.metaUpdate.metaErrors)}>
                                    <s-text tone="critical">{item?.metaUpdate.metaErrors.length} errors</s-text></s-link>
                                : <s-text tone="success">-</s-text>}
                            </s-table-cell>
                            <s-table-cell>{"_"}</s-table-cell>
                            <s-table-cell><s-badge tone={item?.metaUpdate.status === "completed" ? "success" : "info"}>{item?.metaUpdate.status}</s-badge></s-table-cell>
                            <s-table-cell>
                                {item?.metaUpdate?.status !== "completed" && bulkCancelStatus === "" && (item?.update !== null ? item?.update?.status === "completed" : true) && (item?.create !== null ? item?.create?.status === "completed" : true) ?
                                    <s-spinner size='small' />
                                    : null}
                            </s-table-cell>
                        </s-table-row> : null}

                    {emailMarketingUpdate !== undefined ?

                        <s-table-row>
                            <s-table-cell>
                                <s-stack direction="inline" gap="small">
                                    <s-text type="strong"></s-text>
                                </s-stack>
                            </s-table-cell>
                            <s-table-cell><s-text type="strong">Email Marketing</s-text></s-table-cell>
                            <s-table-cell>{emailMarketingUpdate ? emailMarketingUpdate?.timeAgo : "_"}</s-table-cell>
                            <s-table-cell>{emailMarketingUpdate?.completedCount + "/" + emailMarketingUpdate?.total}</s-table-cell>
                            <s-table-cell>{emailMarketingUpdate?.endTime ? FormatTimeDuration(emailMarketingUpdate?.startTime, emailMarketingUpdate?.endTime) : "_"}</s-table-cell>
                            <s-table-cell> <s-text tone="success">-</s-text>
                            </s-table-cell>
                            <s-table-cell>{"_"}</s-table-cell>
                            <s-table-cell><s-badge tone={emailMarketingUpdate?.status === "completed" ? "success" : "info"}>{emailMarketingUpdate?.status}</s-badge></s-table-cell>
                            <s-table-cell>
                                {emailMarketingUpdate?.status !== "completed" ?
                                    <s-spinner size='small' />
                                    : null}
                            </s-table-cell>
                        </s-table-row>
                        : null}

                    {item?.publish ?
                        <s-table-row>
                            <s-table-cell>
                                <s-stack direction="inline" gap="small">
                                    <s-text type="strong">{item?.publish ? "" : '#' + item?.id}</s-text>
                                    {item?.catalogUrl && item?.publish === null ? (
                                        <s-link url={item?.catalogUrl} download={item?.catalogUrl.split('/').pop()}>
                                            <s-icon type="upload" tone='base' />
                                        </s-link>
                                    ) : null}
                                </s-stack>
                            </s-table-cell>
                            <s-table-cell><s-text type="strong">Publish</s-text></s-table-cell>
                            <s-table-cell>{item?.publish.startTime ? item?.publish.timeAgo : "_"}</s-table-cell>
                            <s-table-cell>{item?.publish.completed + "/" + item?.publish.total}</s-table-cell>
                            {/* <s-table-cell><div style={{ width: '125px' }}>
                                <ProgressBar progress={item?.create.completed != 0 ? (item?.create.completed / item?.create.total) * 100 : 0} size="medium" />
                            </div></s-table-cell> */}
                            <s-table-cell>{item?.publish.endTime ? FormatTimeDuration(item?.publish.startTime, item?.publish.endTime) : "_"}</s-table-cell>
                            <s-table-cell>{(item?.publish.errors && item?.publish.errors.length > 0) ?
                                <s-link tone="critical" onClick={() => generateProductErrorModal(item?.publish.errors)}>
                                    <s-text tone="critical">{item?.publish.errors.length} errors</s-text></s-link>
                                : <s-text tone="success">-</s-text>}
                            </s-table-cell>
                            <s-table-cell>{"_"}</s-table-cell>
                            <s-table-cell><s-badge tone={item?.publish.status === "completed" ? "success" : "info"}>{item?.publish.status}</s-badge></s-table-cell>
                            <s-table-cell>
                                {item?.publish?.status !== "completed" && (item?.update !== null ? item?.update?.status === "completed" : true) && bulkCancelStatus === "" ?
                                    <s-spinner size='small' />
                                    : null}
                            </s-table-cell>
                        </s-table-row> : null}

                    {item?.unPublish ?
                        <s-table-row>
                            <s-table-cell>
                                {/* <s-text type="strong"></s-text> */}
                                <s-stack direction="inline" gap="small">
                                    <s-text type="strong">{item?.unPublish ? "" : '#' + item?.id}</s-text>
                                    {item?.catalogUrl && item?.unPublish === null ? (
                                        <s-link url={item?.catalogUrl} download={item?.catalogUrl.split('/').pop()}>
                                            <s-icon type="upload" tone='base' />
                                        </s-link>
                                    ) : null}
                                </s-stack>
                            </s-table-cell>
                            <s-table-cell><s-text type="strong">Unpublish</s-text></s-table-cell>
                            <s-table-cell>{item?.unPublish.startTime ? item?.unPublish.timeAgo : "_"}</s-table-cell>
                            <s-table-cell>{item?.unPublish.completed + "/" + item?.unPublish.total}</s-table-cell>
                            {/* <s-table-cell><div style={{ width: '125px' }}>
                                <ProgressBar progress={item?.create.completed != 0 ? (item?.create.completed / item?.create.total) * 100 : 0} size="medium" />
                            </div></s-table-cell> */}
                            <s-table-cell>{item?.unPublish.endTime ? FormatTimeDuration(item?.unPublish.startTime, item?.unPublish.endTime) : "_"}</s-table-cell>
                            <s-table-cell>{(item?.unPublish.errors && item?.unPublish.errors.length > 0) ?
                                <s-link tone="critical" onClick={() => generateProductErrorModal(item?.unPublish.errors)}>
                                    <s-text tone="critical">{item?.unPublish.errors.length} errors</s-text></s-link>
                                : <s-text tone="success">-</s-text>}
                            </s-table-cell>
                            <s-table-cell>{"_"}</s-table-cell>
                            <s-table-cell><s-badge tone={item?.unPublish.status === "completed" ? "success" : "info"}>{item?.unPublish.status}</s-badge></s-table-cell>
                            <s-table-cell>
                                {item?.unPublish?.status !== "completed" && (item?.update !== null ? item?.update?.status === "completed" : true) && bulkCancelStatus === "" ?
                                    <s-spinner size='small' />
                                    : null}
                            </s-table-cell>
                        </s-table-row> : null}
                </s-table-body>
                </s-table>
                </s-stack>
        </s-section>
        </s-box>
    );
}